import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { generateKeyFromTab } from '@sravni/ugc/lib/specialOffers/helpers';

import type { CustomOneTabsComponentProps } from '../../../helpers/getComponentByTabType';
import type { EventPayload } from '../../../helpers/sendMessageToParentWindow';
import type { TOrdersByType } from '../../../interfaces/orders';
import { useActiveTabType } from '../../../store/hooks/offers';
import { useIsOrdersLoaded, useOrders } from '../../../store/hooks/orders';
import { useUser } from '../../../store/hooks/users';
import { fetchOrders } from '../../../store/reducers/orders';
import type { IActionBlockList } from '../../BlockList/components/HorizontalBlockList';
import { HorizontalBlockList } from '../../BlockList/components/HorizontalBlockList';

export const Osago = memo<CustomOneTabsComponentProps>(
  ({ isMobile, setShowPreloader, sendMessageToParentWindow, ...props }) => {
    const dispatch = useDispatch();
    const user = useUser();
    const activeTabType = useActiveTabType();

    const orders = useOrders();
    const isOrdersLoaded = useIsOrdersLoaded();

    const actions = Object.entries({
      ...orders,
    }).reduce((acc, [key, value]) => {
      if (isMobile)
        return {
          ...acc,
          [key]: ((value as unknown) as any[]).slice(0, 2),
        };

      return {
        ...acc,
        [key]: value,
      };
    }, {} as TOrdersByType);

    const activeActions = actions?.[generateKeyFromTab(activeTabType)];
    const activeActionsCount = activeActions?.length;

    useEffect(() => {
      if (!user?.sub) {
        sendMessageToParentWindow({ type: 'itemsCount', itemsCount: 0 });
        return;
      }

      dispatch(
        fetchOrders({
          ProductTypes: ['osago'],
          PageSize: 0,
        }),
      );

      // Расчеты пока отключаем
      // dispatch(fetchCalculations({ accessToken })),

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
      if (!isOrdersLoaded) {
        setShowPreloader.on();
        return;
      }

      setShowPreloader.off();
      const loadedActionsCount = activeActionsCount ?? 0;
      sendMessageToParentWindow({ type: 'itemsCount', itemsCount: loadedActionsCount });

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeActionsCount, isOrdersLoaded]);

    const handleEvent = useCallback(
      (event: EventPayload) =>
        sendMessageToParentWindow({
          type: 'pushEvent',
          event,
        }),
      [sendMessageToParentWindow],
    );

    const propsForBlockList: IActionBlockList = {
      items: activeActions,
      handleEvent,
      isMobile,
      blocksInTwoRows: false,
      ...props,
    };

    return <HorizontalBlockList {...propsForBlockList} />;
  },
);
